/**
 * Landing legada (Carbon Assets / Retirements) — mantida em /old_landing_page
 * para referência de integração com API e componentes. Não é a home pública.
 */
import React, { useRef, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import CarbonAssets from '../landing/CarbonAssets';
import CarbonRetirements from '../landing/CarbonRetirements';
import Logo from '../../assets/logo-vert-inpi.png';
import LanguageFlags from '../../components/LanguageFlags';
import { useLanguage } from '../../contexts/LanguageContext';
import { getTranslation } from '../../locales';
import {
  LandingContainer,
  Navbar,
  NavLeft,
  NavRight,
  LogoContainer,
  LogoImage,
  NavItems,
  NavItem,
  NavLink,
  NavButton,
  MobileMenuButton,
  HamburgerLine,
  MobileMenu,
  MobileNavItems,
  MobileNavItem,
  MobileNavLink,
  HeroSection,
  HeroTitle,
  HeroSubtitle,
  CTAButton,
} from '../landing/styles';

const OldLandingPage = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();
  const t = getTranslation(language);

  const carbonAssetsRef = useRef(null);
  const carbonRetirementsRef = useRef(null);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleAccessPlatform = () => {
    navigate('/');
  };

  const handleRegister = () => {
    navigate('/register');
  };

  const scrollToSection = (ref) => {
    if (ref && ref.current) {
      const navbarHeight = 80;
      const elementTop = ref.current.offsetTop - navbarHeight;
      window.scrollTo({
        top: elementTop,
        behavior: 'smooth'
      });
    }
  };

  const scrollToCarbonAssets = () => {
    scrollToSection(carbonAssetsRef);
  };

  const scrollToCarbonRetirements = () => {
    scrollToSection(carbonRetirementsRef);
  };

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  const scrollToCarbonAssetsMobile = () => {
    scrollToSection(carbonAssetsRef);
    closeMobileMenu();
  };

  const scrollToCarbonRetirementsMobile = () => {
    scrollToSection(carbonRetirementsRef);
    closeMobileMenu();
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMobileMenuOpen && !event.target.closest('.mobile-menu')) {
        closeMobileMenu();
      }
    };

    const handleResize = () => {
      if (window.innerWidth > 768) {
        closeMobileMenu();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    window.addEventListener('resize', handleResize);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      window.removeEventListener('resize', handleResize);
    };
  }, [isMobileMenuOpen]);

  return (
    <LandingContainer>
      <Navbar>
        <NavLeft>
          <LogoContainer>
            <LogoImage
              src={Logo}
              alt="Vert Ecotech Logo"
              style={{
                width: '4rem',
              }}
            />
          </LogoContainer>
          <NavItems>
            <NavLink
              href="https://vertecotech.io/blog-2/"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t.navbar.projects}
            </NavLink>
            <NavItem onClick={scrollToCarbonAssets}>
              {t.navbar.carbonPackages}
            </NavItem>
            <NavItem onClick={scrollToCarbonRetirements}>
              {t.navbar.retirements}
            </NavItem>
            <NavLink
              href="https://vertecotech.io"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t.navbar.moreInfo}
            </NavLink>
          </NavItems>
          <MobileMenuButton onClick={toggleMobileMenu}>
            <HamburgerLine className={isMobileMenuOpen ? 'open' : ''} />
            <HamburgerLine className={isMobileMenuOpen ? 'open' : ''} />
            <HamburgerLine className={isMobileMenuOpen ? 'open' : ''} />
          </MobileMenuButton>
        </NavLeft>
        <NavRight>
          <LanguageFlags />
          <NavButton onClick={handleAccessPlatform}>
            {t.navbar.accessPlatform}
          </NavButton>
        </NavRight>
      </Navbar>

      <MobileMenu className={`mobile-menu ${isMobileMenuOpen ? 'open' : ''}`}>
        <MobileNavItems>
          <MobileNavLink
            href="https://vertecotech.io/blog-2/"
            target="_blank"
            rel="noopener noreferrer"
            onClick={closeMobileMenu}
          >
            {t.navbar.projects}
          </MobileNavLink>
          <MobileNavItem onClick={scrollToCarbonAssetsMobile}>
            {t.navbar.carbonPackages}
          </MobileNavItem>
          <MobileNavItem onClick={scrollToCarbonRetirementsMobile}>
            {t.navbar.retirements}
          </MobileNavItem>
          <MobileNavLink
            href="https://vertecotech.io"
            target="_blank"
            rel="noopener noreferrer"
            onClick={closeMobileMenu}
          >
            {t.navbar.moreInfo}
          </MobileNavLink>
        </MobileNavItems>
      </MobileMenu>

      <HeroSection>
        <HeroTitle>
          {t.hero.title}
        </HeroTitle>
        <HeroSubtitle>
          {t.hero.subtitle}
        </HeroSubtitle>
        <CTAButton onClick={handleRegister}>
          {t.hero.ctaButton}
        </CTAButton>
      </HeroSection>

      <div ref={carbonAssetsRef}>
        <CarbonAssets />
      </div>

      <div ref={carbonRetirementsRef}>
        <CarbonRetirements />
      </div>

    </LandingContainer>
  );
};

export default OldLandingPage;
